module.exports = __webpack_public_path__ + "static/media/Niveau_elN11_1_924040.61665eff.png";